// /PurchaseOrderRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import PurchaseOrderRecordFilters from "./components/PurchaseOrderRecordFilters";
import PurchaseOrderRecordTable from "./components/PurchaseOrderRecordTable"; // ✅ use correct table
import { fetchPurchaseOrderRecord } from "./PurchaseOrderRecordThunk";
import ReportDom from "../../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const PurchaseOrderRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // 👇 pull data safely (avoid destructuring undefined)
  const purchaseOrderState = useSelector((state) => state.purchaseOrderRecord) || {};
  const { filters = {}, list = [] } = purchaseOrderState;

  useEffect(() => {
    dispatch(fetchPurchaseOrderRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Purchase Order Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="purchase-order-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Purchase Order Record</Title>
            </Flex>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <PurchaseOrderRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <PurchaseOrderRecordTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Purchase Order Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <PurchaseOrderRecordTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default PurchaseOrderRecord;
